import axios from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { MccGroupListResponse } from 'src/models/mccGroup.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'

export const GET_MCC_GROUPS_INIT = 'data/mccGroups/GET_MCC_GROUPS_INIT'
export const GET_MCC_GROUPS_SUCCESS = 'data/mccGroups/GET_MCC_GROUPS_SUCCESS'
export const GET_MCC_GROUPS_FAILURE = 'data/mccGroups/GET_MCC_GROUPS_FAILURE'

export interface GetMccGroupsSuccessPayload {
  mccGroups: MccGroupListResponse[]
}

export interface GetMccGroupsInitAction {
  type: typeof GET_MCC_GROUPS_INIT
}
export interface GetMccGroupsSuccessAction {
  type: typeof GET_MCC_GROUPS_SUCCESS
  payload: GetMccGroupsSuccessPayload
}
export interface GetMccGroupsFailureAction {
  type: typeof GET_MCC_GROUPS_FAILURE
  payload: unknown
}

export type GetMccGroupsActions =
  | GetMccGroupsInitAction
  | GetMccGroupsSuccessAction
  | GetMccGroupsFailureAction

const createGetMccGroupsInitAction = (): GetMccGroupsInitAction => ({
  type: GET_MCC_GROUPS_INIT,
})
const createGetMccGroupsSuccessAction = (
  payload: GetMccGroupsSuccessPayload,
): GetMccGroupsSuccessAction => ({
  type: GET_MCC_GROUPS_SUCCESS,
  payload,
})
const createGetMccGroupsFailureAction = (
  err: unknown,
): GetMccGroupsFailureAction => ({
  type: GET_MCC_GROUPS_FAILURE,
  payload: err,
})

export const getMccGroups = (): ThunkAction<
  Promise<void>,
  RootState,
  void,
  GetMccGroupsActions
> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetMccGroupsActions>,
    getState: () => RootState,
  ): Promise<void> => {
    dispatch(createGetMccGroupsInitAction())
    return axios
      .get(`/mccgroups`, selectAuthedJsonApiRequestConfig(getState()))
      .then(
        (response) => {
          dispatch(createGetMccGroupsSuccessAction(response.data))
        },
        (err) => {
          dispatch(createGetMccGroupsFailureAction(err.response.data))
        },
      )
  }
}
